import { jsx } from 'react/jsx-runtime';

const SvgActionBookmarkFill = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M20 22.73V2H4v20.73l8-4.62 8 4.62Z" }) }));

export { SvgActionBookmarkFill as default };
//# sourceMappingURL=ActionBookmarkFill.es.js.map
